<template>
    <div class="fill">
        <LocationTracker/>
        <b-container>
            <!-- top bar cta -->
            <b-row class="my-3">
                <b-col cols="1"></b-col>
                <b-col cols="auto" class="mr-auto p-3">
                    <b-button variant="outline" class="text-light mr-2"><strong>Write a Review</strong></b-button>
                    <b-button variant="outline" class="text-light mr-2"><strong>Events</strong></b-button>
                    <b-button variant="outline" class="text-light mr-2"><strong>Talk</strong></b-button>
                </b-col>
                <b-col cols="auto" class="p-3">
                    <b-button variant="outline" class="text-light mr-2"><strong>Log In</strong></b-button>
                    <b-button variant="outline-primary" class="cta mr-2"><strong>Sign Up</strong></b-button>
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
            <!-- logo -->
            <b-row class="pb-4 justify-content-md-center">
                <b-col cols="12" md="auto">
                    <a href="#">
                        <b-img width="90px" src="https://i.imgur.com/aicQCL8.png" />
                    </a>
                </b-col>
            </b-row>
            <b-row class="py-4 justify-content-md-center">
                <b-col cols="1"></b-col>
                <b-col cols="10" md="auto">
                    <SearchInputGroup />
                </b-col>
                <b-col cols="1"></b-col>
            </b-row>
            <b-row class="pb-4 justify-content-md-center">
                <b-col cols="12" md="auto" style="display: flex;">
                    <div>
                        <b-button class="text-light font-weight-bold" variant="outline">
                            <b-icon icon="droplet-fill" aria-hidden="true"></b-icon> Plumbers
                        </b-button>
                    </div>
                    <div>
                        <b-button class="text-light font-weight-bold" variant="outline">
                            <b-icon icon="egg-fried" aria-hidden="true"></b-icon> Restaurants
                        </b-button>
                    </div>
                    <div>
                        <b-dropdown toggle-class="text-light font-weight-bold" variant="outline" ref="dropdown1">
                            <template #button-content>
                                <b-icon icon="house-door-fill"/> Home Services
                            </template>
                            <b-dropdown-item href="#">Air Conditioning</b-dropdown-item>
                            <b-dropdown-item href="#">Electricians</b-dropdown-item>
                            <b-dropdown-item href="#">Contractors</b-dropdown-item>
                            <b-dropdown-item href="#">Painters</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div>
                        <b-button class="text-light font-weight-bold" variant="outline">
                            <b-icon icon="bicycle" aria-hidden="true"></b-icon> Delivery
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row style="height: 120px" />
            <b-row align-v="end" class="pb-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto" style="display: block;">
                    <b-tooltip target="showcasedPlace" variant="overwhite2-white">
                        <template #default>
                            <PlaceTooltip />
                        </template>
                    </b-tooltip>
                    <div id="showcasedPlace" class="text-light font-weight-bold text-center">Revival</div>
                    <div class="text-light text-center">Photo by <b-link href="#" class="text-light"> <strong>Ivan M.</strong></b-link></div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
/* .box {
    overflow:hidden;
    white-space:nowrap;
    height: 420px;
    object-fit: cover;
    filter: brightness(100%);
} */

.fill {
    overflow: hidden;
    background-size: cover;
    background-position: center;
    height: 570px;
    width: 100vw;
    background-image: url('https://s3-media0.fl.yelpcdn.com/assets/srv0/yelp_large_assets/eea3522f4348/assets/img/home/hero_photos/BWRT755ImlKnGpjV4udRdQ.jpg');
}

.cta {
    color: white
}

.btn-outline-primary {
    border-color: white;
    border-width: 2px;
}

.tooltip::v-deep .tooltip-inner{
    max-width: 600px !important;
}

/* .test1 {
    max-width: 4000px;
} */

</style>

<script>
import PlaceTooltip from './PlaceTooltip'
import LocationTracker from '../common/LocationTracker'
import SearchInputGroup from '../search/SearchInputGroup'


export default {
    components: {
        PlaceTooltip,
        LocationTracker,
        SearchInputGroup
    },
    data() {
        return {
            
        }
    },
    methods: {
        
    },
    computed: {
        
    },
    mounted() {
        console.log('mounted from Imagery')
    }
}
</script>